export default __webpack_public_path__ + "static/media/r7.adec1340.jpeg";